import { render } from "./LearnMore.vue?vue&type=template&id=3d77b7a4&scoped=true"
import script from "./LearnMore.vue?vue&type=script&lang=js"
export * from "./LearnMore.vue?vue&type=script&lang=js"

import "./LearnMore.vue?vue&type=style&index=0&id=3d77b7a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d77b7a4"]])

export default __exports__